import {Locales} from '@netx/core-next/locales/utils/Locales';
import {
	StatDateType,
	StatQueryObjectType,
	StatType,
	StatQueryStatusType,
} from './constants';

export const StatsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.statistics'),
}));

export const StatDateTypeLabel: Record<StatDateType, string> = Locales(
	(i18n) => ({
		[StatDateType.TODAY]: i18n('i18n.today'),
		[StatDateType.THIS_WEEK]: i18n('i18n.thisWeek'),
		[StatDateType.THIS_MONTH]: i18n('i18n.thisMonth'),
		[StatDateType.THIS_YEAR]: i18n('i18n.thisYear'),
		[StatDateType.SELECTED_DATE]: i18n('i18n.selectedDate'),
		[StatDateType.BEFORE_DATE]: i18n('i18n.beforeDate'),
		[StatDateType.AFTER_DATE]: i18n('i18n.afterDate'),
		[StatDateType.BETWEEN_DATES]: i18n('i18n.betweenDates'),
	}),
);

export const StatTypeLabel: Record<StatType, string> = Locales((i18n) => ({
	[StatType.APPROVED_DOWNLOAD_REQUEST_ASSETS]: i18n(
		'i18n.approvedDownloadRequestAssets',
	),
	[StatType.APPROVED_DOWNLOAD_REQUESTS]: i18n('i18n.approvedDownloadRequests'),
	// [StatType.ASSET_ARCHIVED]: i18n('i18n.assetsArchived'),
	[StatType.ASSET_DOWNLOADS]: i18n('i18n.assetDownloads'),
	// [StatType.ASSET_UNARCHIVED]: i18n('i18n.assetsUnarchived'),
	[StatType.ASSETS_CHECKED_IN]: i18n('i18n.assetsCheckedIn'),
	[StatType.ASSETS_CHECKED_OUT]: i18n('i18n.assetsCheckedOut'),
	[StatType.ASSETS_DELETED]: i18n('i18n.assetsDeleted'),
	[StatType.ASSETS_IMPORTED]: i18n('i18n.assetsImported'),
	[StatType.ASSETS_LINKED]: i18n('i18n.assetsLinked'),
	[StatType.ASSETS_PLACED]: i18n('i18n.assetsPlaced'),
	// [StatType.ASSETS_PROCESSED]: i18n('i18n.assetsProcessed'),
	[StatType.ASSETS_SEARCHED]: i18n('i18n.assetsSearched'),
	[StatType.ASSETS_VIEWED]: i18n('i18n.assetsViewed'),
	[StatType.CATEGORIES_DELETED]: i18n('i18n.categoriesDeleted'),
	[StatType.CATEGORIES_VIEWED]: i18n('i18n.categoriesViewed'),
	[StatType.DENIED_DOWNLOAD_REQUEST_ASSETS]: i18n(
		'i18n.deniedDownloadRequestAssets',
	),
	[StatType.DENIED_DOWNLOAD_REQUESTS]: i18n('i18n.deniedDownloadRequests'),
	[StatType.FILE_DOWNLOADS]: i18n('i18n.fileDownloads'),
	[StatType.SESSION_EXPIRATION]: i18n('i18n.sessionExpiration'),
	[StatType.SHARED_ASSETS]: i18n('i18n.sharedAssets'),
	[StatType.SHARED_FILES]: i18n('i18n.sharedFiles'),
	[StatType.USER_LOGINS]: i18n('i18n.userLogins'),
}));

export const StatUsageLabel = {};

export const StatUsageTitle = Locales((i18n) => ({
	ASSETS: i18n('i18n.assets'),
	BANDWIDTH: i18n('i18n.dataTransfer'),
	DETAILS: i18n('i18n.details'),
	JOBS: i18n('i18n.jobs'),
	STORAGE: i18n('i18n.storage'),
	USERS: i18n('i18n.users'),
}));

export const StatQueryObjectTypeLabel: Record<StatQueryObjectType, string> =
	Locales((i18n) => ({
		[StatQueryObjectType.ASSET_ID]: i18n('i18n.assetId'),
		[StatQueryObjectType.CATEGORY_ID]: i18n('i18n.categoryId'),
		[StatQueryObjectType.OBJECT_ID]: i18n('i18n.objectId'),
		[StatQueryObjectType.STATUS]: i18n('i18n.status'),
		[StatQueryObjectType.USER_ID]: i18n('i18n.userId'),
	}));

export const StatQueryStatusTypeLabel: Record<StatQueryStatusType, string> =
	Locales((i18n) => ({
		[StatQueryStatusType.APPROVED]: i18n('i18n.approved'),
		[StatQueryStatusType.DENIED]: i18n('i18n.denied'),
		[StatQueryStatusType.PENDING_APPROVAL]: i18n('i18n.pendingApproval'),
	}));

export const StatQueryListMessage = Locales((i18n) => ({
	NO_RECORDS: i18n('i18n.noRecords'),
	NO_MATCHING_RECORDS: i18n('i18n.noMatches'),
	ERROR: i18n('i18n.error'),
}));

export const StatQueryListColumnLabel = Locales((i18n) => ({
	USER: i18n('i18n.user'),
	ITEM: i18n('i18n.item'),
	DATE: i18n('i18n.date'),
	DOMAIN: i18n('i18n.domain'),
	DETAILS: i18n('i18n.details'),
}));
